export default "__VITE_ASSET__BQJcNKge__"